import { Thread } from "../../types"

export const initialMsgNotReplied = (thread: Thread): boolean =>
  thread.messages.length >= 1 &&
  thread.messages.every(message => message.sender === "system")
